import { satGlobals } from "../../../../../sat/helper/sat-globals"
import { cookieHelper } from "../../../../../helper/cookie"
class DownLoadCookieManager{
    constructor(){
    }
    setDownloadCookie(value){
        const baseDomain = satGlobals.getBaseDomain();

        cookieHelper.setCookie('x-oc-download-password', value, 86400, '/',baseDomain);
    }
}

export default new DownLoadCookieManager()